import { apiClient } from "./api";

export const swingCollectionsService = {
  // POST /api/v1/createSwingCollection
  async createSwingCollection(params) {
    // const { userId, videoIds = [], collectionName } = params;
    return apiClient.request("/api/v1/createSwingCollection", {
      method: "POST",
      body: params,
      requireAuth: true,
    });
  },

  // PATCH /api/v1/updateSwingCollection/:id
  async updateSwingCollection({ collectionId, videoIds, collectionName }) {
    return apiClient.request(`/api/v1/updateSwingCollection/${collectionId}`, {
      method: "PATCH",
      body: { videoIds, collectionName },
      requireAuth: true,
    });
  },

  // GET /api/v1/getSwingCollection/:id
  async getSwingCollection({ collectionId }) {
    return apiClient.request(`/api/v1/getSwingCollection/${collectionId}`, {
      method: "GET",
      requireAuth: true,
    });
  },

  // DELETE /api/v1/deleteSwingCollection/:id
  async deleteSwingCollection({ collectionId }) {
    return apiClient.request(`/api/v1/deleteSwingCollection/${collectionId}`, {
      method: "DELETE",
      requireAuth: true,
    });
  },

  // GET /api/v1/getAllSwingCollectionsByUserId/:id
  async getAllSwingCollectionsByUserId({ userId }) {
    return apiClient.request(
      `/api/v1/getAllSwingCollectionsByUserId/${userId}`,
      {
        method: "GET",
        requireAuth: true,
      },
    );
  },

  // POST /api/v1/llm/comparison-ai-highlight
  async getComparisonAiHighlight({
    collectionOneId,
    collectionTwoId,
    userId,
    overwriteEnv,
  }) {
    return apiClient.request("/api/v1/llm/comparison-ai-highlight", {
      method: "POST",
      body: { collectionOneId, collectionTwoId, userId, overwriteEnv },
      requireAuth: true,
    });
  },

  async preserveLlmSession({ highlightId }) {
    return apiClient.request("/api/v1/llm/preserve-llm-session", {
      body: { highlightId },
      method: "POST",
      requireAuth: true,
    });
  },

  // GET /api/v1/getOutliersFilters – outlier filter options (key positions, movement types). No auth.
  async getOutliersFilters() {
    return apiClient.request("/api/v1/getOutliersFilters", {
      method: "GET",
      requireAuth: false,
    });
  },

  // POST /api/v1/getOutliers – top outliers between two collections. Payload is built by the caller.
  async getOutliers(body) {
    return apiClient.request("/api/v1/getOutliers", {
      method: "POST",
      body,
      requireAuth: true,
    });
  },
};
